export default __webpack_public_path__ + "static/media/human_pt.f63fccac.svg";